export const BORROWER_PORTAL_MAX_WIDTH = 1500;